import purify from 'dompurify';
import Quill from 'quill';
import { useEffect, useState } from 'react';

const quillClassStartPattern = 'ql-';
const quillClassAfterOtherClassPattern = `(\\w|\\s|_|-)*\\s${quillClassStartPattern}`;
const hasQuillClassRegex = new RegExp(
  `\\sclass="(${quillClassStartPattern}|${quillClassAfterOtherClassPattern})`
);

const getSemanticHTMLFromQuillHTML = async (html: string) => {
  const container = document.createElement('div');
  const quill = new Quill(container);
  quill.root.innerHTML = html;

  // Wait for the quill to update the DOM
  await new Promise(resolve => setTimeout(() => resolve(null), 0));

  const semanticHtml = quill.getSemanticHTML();
  return purify.sanitize(semanticHtml);
};

const getCleanHtml = async (html: string) => {
  const isQuillHtml = hasQuillClassRegex.test(html);
  if (isQuillHtml) {
    html = await getSemanticHTMLFromQuillHTML(html);
  }
  return purify.sanitize(html);
};

// Use this component whenever you want to render pure html
// It will sanitize the html before rendering to prevent XSS attacks
const HtmlDisplayer = ({
  innerHtml,
  className,
}: {
  innerHtml: string;
  className?: string;
}) => {
  const [cleanHtml, setCleanHtml] = useState('');

  useEffect(() => {
    getCleanHtml(innerHtml).then(cleanHtml => setCleanHtml(cleanHtml));
  }, [innerHtml]);

  return (
    <div
      style={{ overflowWrap: 'break-word', wordWrap: 'break-word' }}
      className={className}
      dangerouslySetInnerHTML={{ __html: cleanHtml }}
    ></div>
  );
};

export default HtmlDisplayer;
